<template>
  <div class="hcl-form-element-empty">
    <div class="form-group">
      <div class="input-group stretch"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
</script>

<style lang="scss" scoped>
.hcl-form-element-empty {
  width: 100%;

  .stretch {
    width: 100%;
  }
}
</style>
